import React, { useMemo } from 'react';
import Select from 'react-select';
import Input from 'src/components/Input';
import { RoomOption } from 'src/components/AssetsTable/AreaAssetTableComponents/AddRoomDialog';
import CalloutCard from 'src/components/CalloutCard/CalloutCard';
import { selectStyles } from 'src/utils/SharedStyles/SharedTableStyles';
import './PreconfiguredForm.scss';

interface RoomOptionLabelProps {
  label: string;
}

const RoomOptionLabel = ({ label }: RoomOptionLabelProps) => {
  const isAdded: boolean = label.includes('(added)');
  const cleanLabel: string = label.replace(' (added)', '');

  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        width: '100%',
      }}
    >
      <span className="room_option_text">{cleanLabel}</span>
      {isAdded && (
        <small
          className="room_option_status"
          style={{
            fontStyle: 'italic',
            opacity: 0.7,
            fontSize: '12px',
            marginLeft: '10px',
          }}
        >
          (already added to this unit)
        </small>
      )}
    </div>
  );
};

interface Props {
  options: RoomOption[];
  selectedId: string;
  onSelect: (option: RoomOption | null) => void;
  labelValue: string;
  onLabelChange: (val: string) => void;
}

const PreconfiguredForm = ({
  options,
  selectedId,
  onSelect,
  labelValue,
  onLabelChange,
}: Props) => {
  const selectedOption: any = useMemo(() => {
    return options.find((opt: RoomOption) => opt.value === selectedId) || null;
  }, [options, selectedId]);

  return (
    <div className="preconfigured_form_container">
      <div className="input_group">
        <label
          className="reporting__heading"
          style={{ color: 'black', marginBottom: '8px', display: 'block' }}
        >
          Select Room Type
        </label>
        <Select
          value={selectedOption}
          onChange={onSelect}
          options={options}
          styles={selectStyles}
          placeholder="Search preconfigured rooms..."
          isOptionDisabled={(option: any) => option.label.includes('(added)')}
          formatOptionLabel={(option: any) => (
            <RoomOptionLabel label={option.label} />
          )}
        />
        <span className="input_hint">
          Choose from preconfigured rooms for your project.
        </span>
      </div>
      <div className="input_group" style={{ marginTop: '24px' }}>
        <Input
          value={labelValue}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            onLabelChange(e.target.value)
          }
          label="Custom Label (Optional)"
          placeholder="e.g. Master Bedroom, Unit 101 Kitchen"
          block
        />
        <span className="input_hint">
          Distinguish this room from others of the same type.
        </span>
      </div>
      <div style={{ marginTop: '24px' }}>
        <CalloutCard
          icon_type="info"
          message={
            <span>
              These rooms are preconfigured at the tenant level for use across
              all your projects. For unique spaces specific to this unit only,
              please use the <strong>'Custom Room'</strong> tab.
            </span>
          }
        />
      </div>
    </div>
  );
};

export default PreconfiguredForm;
